<template>
  <v-btn
    :color="color"
    block
    :loading="isLoading || $store.getters.isLoading"
    :disabled="!valid"
    rounded
    large
    @click="$emit('click', false)"
  >
    <span class="btn" v-text="$t(title)" />
  </v-btn>
</template>

<script>
export default {
  name: "ButtonOther",
  props: {
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "warning",
    },
    valid: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
